import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import { useFetcher } from '@/api/useGetFetchConfig';

const useGetTermsOfUseContent = (enabled: boolean) => {
  const fetcher = useFetcher();
  const getContent = async () => fetcher<{ markdown: string }>(`${APIBaseChronos}/api/terms-of-use/content`);
  return useQuery([QueryEntity.TermsOfUse], getContent, { enabled, retry: false });
};

export default useGetTermsOfUseContent;
